module.exports = __webpack_public_path__ + "static/look-smarter-than-you-are-with-hyperion-essbase-87eeed235d4b4e5cd0e55b960fe662f7.jpg";